import algoliasearch from 'algoliasearch';

const searchClient = algoliasearch('KW2JZ7ZKK1', 'd9d8f1e22241db742ae54bc21e730756');

export default searchClient;

